import { Collection as AttachmentsCollection } from '@/components/attachment/collection'
import { AttachmentResourceType } from '@/types'
import { Query as ShowQuery } from './show_query'

interface Props {
  categoryId: string
}

export const EditImages = ({ categoryId }: Props) => {
  return (
    <>
      <AttachmentsCollection
        filters={{ nameEq: 'images', resourceIdEq: categoryId, resourceTypeEq: AttachmentResourceType.Category }}
        pageSize={10}
        refetchQueries={[ShowQuery]}
        title="Images"
        createable
        deleteable
        fixedHeight
      />
    </>
  )
}
